import { useEffect, useState } from "react";
import axios from "axios";
import useProfileData from "./useProfileData";
import { useParams } from "react-router-dom";

const baseURL = `${process.env.REACT_APP_API_URL}`


export default function useContracts() {
    const [contract, setContract] = useState(null)
    const { profile } = useProfileData();
    const { id } = useParams();


        const userId = profile?.user_id;


    useEffect(() => {
        const fetchContract = async () => {
            if (!userId) return; 
            try {
                const response = await axios.get(`${baseURL}/profiles/contracts/${id}/`)
                setContract(response.data)
                console.log('fetching contract for house manager with ID:', id)
                console.log('contract fetched:', response.data)
            } catch(error) {
                console.error('Error fetching contract:', error);
            }
        }

        fetchContract();

    }, [userId])

    return { contract };
}